<template>
	<h2 class="placeholder rigid">
		<span class="invisible">{{text}}</span>
	</h2>
</template>

<script>
export default {
	name: 'h2Placeholder',
	props: {
		text: String
	}
};
</script>

<style scoped>
	h2.placeholder{
		background-color: #eee;
	}
	.dark h2.placeholder {
		background-color: #666;
	}
</style>



// WEBPACK FOOTER //
// ./src/components/H2Placeholder.vue